import { DeliveryType } from "./Enums.js";
import { CustomerOverride, resolveCustomerOverride } from "./CustomerOverride.js";
/**
 * The delivery options that really apply: the zone's, with the two overrides a logged-in
 * customer may carry. Table service is a zone-only option, a customer can't override it.
 */
export function resolveDeliveryOptions(zone, customer) {
    return {
        enableDelivery: resolveCustomerOverride(zone ? zone.enableDelivery : false, customer ? customer.enableDelivery : null),
        enablePickup: resolveCustomerOverride(zone ? zone.enablePickup : false, customer ? customer.enablePickup : null),
        enableTableService: Boolean(zone && zone.enableTableService),
    };
}
/**
 * Whether the given delivery type may be used at all for this zone/customer combination.
 */
export function isDeliveryTypeAvailable(deliveryType, zone, customer) {
    if (!zone || !deliveryType) {
        return false;
    }
    let options = resolveDeliveryOptions(zone, customer);
    if (deliveryType == DeliveryType.delivery) {
        return options.enableDelivery;
    }
    if (deliveryType == DeliveryType.takeaway) {
        return options.enablePickup;
    }
    if (deliveryType == DeliveryType.table) {
        return options.enableTableService;
    }
    return false;
}
